import { format, parse } from "date-fns";

import { Advertiser, AdvertiserB2 } from "@/store/modules/projectEdit";
import { AdvertiserExtendedListEntity } from "@/types/plans";

export const extractTenantProps = (tenant: Record<string, unknown>) => {
  const props = tenant?.props;

  if (typeof props === "object" && props !== null) {
    return props;
  }

  if (typeof props === "string") {
    try {
      return JSON.parse(props);
    } catch (e) {
      console.error("Error parsing Json:", e);
    }
  }

  return {};
};

export const unpackDetailedAdvertiser = (advertisers: AdvertiserExtendedListEntity[]) => {
  return advertisers.map((a) => ({
    advertiser_name: a.advertiser_name ?? "-",
    industry: a.industry ?? "-",
    sub_industry: a.sub_industry ?? "-",
    profile_type: a.profile_type ?? "-",
    estimated_audience_size: a.estimated_audience_size ?? "-",
    estimated_time_to_conversion: a.estimated_time_to_conversion ?? "-",
    average_order_value: a.average_order_value ?? "-",
    brand_recognition: a.brand_recognition ?? "-",
    pixeling_experience: a.pixeling_experience ?? "-",
    website_conversion_experience: a.website_conversion_experience ?? "-",
    date_of_rating: a.date_of_rating ? format(parse(a.date_of_rating, "yyyy-MM-dd", new Date()), "yyyy-MM-dd") : "-",
    url: a.url ?? "-",
  }));
};

export function normalizeB2(b2?: AdvertiserB2 | null) {
  if (!b2 || (typeof b2 === "object" && Object.keys(b2).length === 0)) return null;
  return {
    pixeling_experience: b2.pixeling_experience ?? null,
    website_conversion_experience: b2.website_conversion_experience ?? null,
    average_order_value: b2.average_order_value ?? null,
    brand_recognition: b2.brand_recognition ?? null,
    estimated_time_to_conversion: b2.estimated_time_to_conversion ?? null,
    estimated_audience_size: b2.estimated_audience_size ?? null,
  };
}

export function normalizeAdvertiserShape(a?: Partial<Advertiser> | null) {
  a = a || {};
  return {
    id: a.id ?? "",
    name: a.name ?? "",
    industry: a.industry ?? "",
    sub_industry: a.sub_industry ?? "",
    url: a.url ?? null,
    agency_id: a.agency_id ?? "",
    b2b: normalizeB2(a.b2b),
    b2c: normalizeB2(a.b2c),
  };
}
